module.exports = __webpack_public_path__ + "static/media/guest.ded65774.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guest.jpg
// module id = 255
// module chunks = 0